import { ref } from 'vue'

export type PageTypes = 'Main' | 'ChatGallery' | 'ChatSearch' | 'GroupEvents'
export const sheet = ref<PageTypes>('Main')
